import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=96886d7a&scoped=true&shadow"
import script from "./Button.vue?vue&type=script&lang=js&shadow"
export * from "./Button.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Button.vue?vue&type=style&index=0&id=96886d7a&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "96886d7a",
  null
  ,true
)

export default component.exports